import { SharedWetterDe as KMM } from '@/lib/kmm/SharedWetterDe'

export default KMM
